"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var NotificationService = function NotificationService(toastr) {
    "ngInject";

    var warning = function warning(message) {
        toastr.warning(message);
    };

    var success = function success(message) {
        toastr.success(message);
    };

    var error = function error(message) {
        toastr.error(message);
    };

    return { warning: warning, success: success, error: error };
};

exports.default = NotificationService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/notification.service.js
 **/